import { Skeleton } from '@ahafood/ui/components/skeleton';
import { useIsMobile } from '@/lib/is-mobile';

export default function BannerSkeleton() {
  const isMobile = useIsMobile();

  return (
    <section className="bg-transparent py-4 md:py-8">
      <div className="mx-auto w-full max-w-screen-xl px-4 md:px-6">
        <div className="flex gap-4 w-full overflow-hidden">
          <Skeleton
            className="rounded-xl shrink-0 bg-neutral-10"
            style={{
              width: isMobile ? '100%' : '49%',
              aspectRatio: '1000/443',
              maxHeight: isMobile ? '180px' : '443px',
            }}
          />
          {!isMobile && (
            <Skeleton
              className="rounded-xl shrink-0 bg-neutral-10"
              style={{
                width: '49%',
                aspectRatio: '1000/443',
                maxHeight: '443px',
              }}
            />
          )}
        </div>
      </div>
    </section>
  );
}
